import { AccessTime } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { List } from "@dzambalaorg/ui-kit";

import { StyledPaper } from "../styled";

export const AssetPromoSection = () => {
  return (
    <StyledPaper>
      <List
        component="nav"
        subheader={
          <List.Subheader>
            <FormattedMessage id="pages.dashboard.mechanics.promo" />
          </List.Subheader>
        }
      >
        <List.ItemButton<typeof RouterLink> component={RouterLink} to="/promos">
          <List.ItemIcon>
            <AccessTime />
          </List.ItemIcon>
          <List.ItemText>
            <FormattedMessage id="pages.promo-list.title" />
          </List.ItemText>
        </List.ItemButton>
      </List>
    </StyledPaper>
  );
};
